export default class Utils {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static toObject(obj: any): object {
    return JSON.parse(JSON.stringify(obj));
  }
}
